<template>

    <svg v-svg
        class="icon"
        role="presentation"
        :style="styles"
        :symbol="symbol"
        :size="width && height ? `0 0 ${width} ${height}` : `0 0 ${size} ${size}`"
        :fill="fill">
    </svg>

</template>

<style scoped lang="scss">

    .icon {
        display: inline-block;
        flex-shrink: 0;
        line-height: 0;
        margin: 0;
        overflow: hidden;
        padding: 0;
    }

</style>

<script>

export default {

    props: {
        symbol: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            default: 'none',
        },
        size: {
            type: Number,
            default: 100,
        },
        width: {
            type: Number,
        },
        height: {
            type: Number,
        },
        radius: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            colors: {
                'none': 'auto',
                'white': '#ffffff',
                'dark': '#222222',
                'primary': '#0064ff',
                'secondary': '#999999',
                'danger': '#ec2e52',
                'success': '#2EC76F',
            },
        }
    },

    computed: {

        styles() {
            return {
                'border-radius': `${this.radius}px`,
                'width': this.width || this.size,
                'height': this.height || this.size,
            };
        },

        fill() {
            return this.colors[this.type];
        },

    },

}

</script>
